import classNames from "classnames";
import { get } from "lodash";
import format from "string-template";
import Card from "./Card";

const EmailTemplate = ({
  civility,
  lastName,
  firstName,
  currentDate,
  endOfValidityDate,
  adminPhoneNumber,
  adminFirstName,
  adminLastName,
  adminEmail,
  adminAddress,
  translation,
  costs,
  addLinks,
  upsells,
}) => {
  return (
    <div className="quote-template-amellis__main-container">
      <div className="quote-template-amellis__header">
        <img
          src="https://assets.kayros.tech/amellis/logo.png"
          alt="AMELLIS Logo"
        />
      </div>
      <div className="quote-template-amellis__container">
        <div className="quote-template-amellis__content">
          <p>
            {translation.HELLO}{" "}
            <strong>
              {translation[civility] || civility} {firstName} {lastName}
            </strong>
            ,
          </p>
          <p>{translation.P1}</p>
          <p>
            {translation.P2} {currentDate}.
          </p>
          <p>{translation.P3}</p>
          <p>
            {translation.P4}{" "}
            <span className="quote-template-amellis__highlight">
              {endOfValidityDate}
            </span>
            .
          </p>
        </div>
        <div className="quote-template-amellis__content">
          <div className="quote-template-amellis__submit--link">
            <div className="quote-template-amellis__submit">
              {translation.BUTTON}
            </div>
          </div>
        </div>
        <div className={classNames({ hidden: !addLinks })}>
          <div className="quote-template-amellis__content">
            <p className="subtitle">{translation.P5}</p>
          </div>
          {costs?.map(({ id, insurancePlan, cost, currency }) => {
            const insuranceUpsells = get(upsells, insurancePlan.id, []);
            const totalCost = insuranceUpsells.reduce(
              (acc, { cost }) => (acc += cost),
              cost,
            );
            return (
              <Card
                key={id}
                icon={insurancePlan?.icon}
                name={insurancePlan?.name}
                cost={totalCost}
                currency={currency}
                period={translation.PER_MONTH}
                perYear={translation.PER_YEAR}
                allIncluded={translation.ALL_INCLUDED}
                link={translation.LINK}
                upsells={insuranceUpsells}
              />
            );
          })}
        </div>
        <div className="quote-template-amellis__content">
          <p>{format(translation.P6, { adminPhoneNumber })}</p>
          <p>
            {translation.P7}
            <br />
            {translation.P8}
          </p>
          {/* <p>{translation.YOUR_ADVISOR}</p> */}
        </div>
        <div className="quote-template-amellis__info">
          <p className="quote-template-amellis__info--name">
            {adminFirstName} {adminLastName}
          </p>
          <p>{translation.AMELLIS}</p>
          <p>{adminEmail}</p>
          <p>{adminPhoneNumber}</p>
          <p>{adminAddress}</p>
        </div>
      </div>
      <div className="quote-template-amellis__footer">
        <p className="quote-template-amellis__footer--title">
          {translation.AMELLIS}
        </p>
        <p>8 Rue de la Poyat, 39200 Saint-Claude</p>
      </div>
    </div>
  );
};

export default EmailTemplate;
